// extracted by mini-css-extract-plugin
export var chatHtmlText = "_n0-2";
export var chatLink = "_n0-0";
export var chatText = "_n0-1";